import RepairsOrders from "./RepairsOrders";
export default RepairsOrders;